export const enum TerritorySelectedTab {
  explore = 'explore',
  community = 'community',
  rewards = 'rewards',
}
export const TERRITORY_MEMBERS_INITIAL_COUNT = 15;

export const TERRITORY_COMMUNITY_SECTION_QUERY_NAME = 'territory-community-section';
